import { rootApi } from '../rootApi';

export const vehicleParkReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getVehicleParkReport: builder.query({
            query: (body) => ({
                url: 'v1/vehiclepark/getlist',
                method: 'POST',
                body: {
                    pageSize: body.pageSize ?? 20,
                    pageNumber: body.pageNumber ?? 1,
                    filters: body.filters ?? null,
                    sorts: body.sorts ?? null,
                },
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                        filterOptions: response.data.filterOptions ?? null,
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['VehicleParkReport'],
        }),
        exportVehicleParkToExcel: builder.query({
            query: (body) => ({
                url: 'v1/VehiclePark/ExportToExcel',
                method: 'POST',
                body: {
                    filters: body.filters ?? null,
                    sorts: body.sorts ?? null,
                    LanguageId: body.LanguageId,
                    compressionType: body.compressionType ?? 1,
                },
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || response?.message || 'Export başarısız oldu');
            },
        }),
    }),
});

export const { useGetVehicleParkReportQuery, useLazyExportVehicleParkToExcelQuery } = vehicleParkReportApi;
